import type { HTMLComponent } from "@commercekit/react";

const WvCloseIcon: HTMLComponent<{ size?: number }> = ({ size = 17 }) => {
  return (
    <svg
      style={{ transform: `scale(${size / 17})` }}
      width="17"
      height="17"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.057 8.5l6.62-6.62A1.1 1.1 0 1015.12.323L8.5 6.943 1.88.323A1.1 1.1 0 10.323 1.88l6.62 6.62-6.62 6.62A1.1 1.1 0 001.102 17c.282 0 .564-.108.778-.323l6.62-6.62 6.62 6.62a1.098 1.098 0 001.557 0 1.1 1.1 0 000-1.557l-6.62-6.62z"
        fill="currentColor"
        fillRule="nonzero"
        opacity=".79"
      ></path>
    </svg>
  );
};

export default WvCloseIcon;
